import { z } from 'zod';

export const UPSTREAM_ALGORITHMS = [
  'ROUND_ROBIN',
  'WEIGHTED_ROUND_ROBIN',
  'LEAST_CONNECTIONS',
  'IP_HASH',
] as const;

export const upstreamFormSchema = z.object({
  name: z
    .string()
    .min(1, '이름을 입력하세요')
    .max(128, '최대 128자'),
  description: z.string().max(500, '최대 500자').optional(),
  algorithm: z.enum(UPSTREAM_ALGORITHMS).default('ROUND_ROBIN'),
  hashOn: z.string().optional(),
  healthcheckActive: z.boolean().default(false),
  healthcheckPassive: z.boolean().default(false),
  algorithmConfig: z.record(z.unknown()).optional(),
  enabled: z.boolean().default(true),
});

export type UpstreamFormValues = z.infer<typeof upstreamFormSchema>;
